import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../commonsCapacities";

export const FETCH_DELETE_COMMONS_CAPACITIES_REQUEST = 'FETCH_DELETE_COMMONS_CAPACITIES_REQUEST';
export const FETCH_DELETE_COMMONS_CAPACITIES_SUCCESS = 'FETCH_DELETE_COMMONS_CAPACITIES_SUCCESS';
export const FETCH_DELETE_COMMONS_CAPACITIES_FAILURE = 'FETCH_DELETE_COMMONS_CAPACITIES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteCommonsCapacitiesRequest = () => {
    return {
        type: FETCH_DELETE_COMMONS_CAPACITIES_REQUEST,
    };
};

const fetchDeleteCommonsCapacitiesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_COMMONS_CAPACITIES_SUCCESS,
        payload: data
    };
};

const fetchDeleteCommonsCapacitiesFailure = (error: any) => {
    return {
        type: FETCH_DELETE_COMMONS_CAPACITIES_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteCommonsCapacitiesRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteCommonsCapacitiesSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteCommonsCapacitiesFailure(error.message));
        }
    };
};
